import OperatorTdsDeclarationTypes from './types';

export const fetchOperatorBasicDetailsStart = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_BASIC_DETAILS_START,
  payload: payload,
});

export const fetchOperatorBasicDetailsSuccess = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_BASIC_DETAILS_SUCCESS,
  payload: payload,
});

export const fetchOperatorBasicDetailsFailure = (errorMessage: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_BASIC_DETAILS_FAILURE,
  payload: errorMessage,
});

export const initiateOperatorUndertakingStart = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_UNDERTAKING_START,
  payload: payload,
});

export const initiateOperatorUndertakingSuccess = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_UNDERTAKING_SUCCESS,
  payload: payload,
});

export const initiateOperatorUndertakingFailure = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_UNDERTAKING_FAILURE,
  payload: payload,
});
